import { gql } from 'graphql-request';

export const CREATE_POA_USER = gql`
  mutation CreatePoaUser($userType: String!, $request: JSONObject!) {
    corePOAUsers {
      createRepresentative(input: { userType: $userType, request: $request })
    }
  }
`;
